<style lang="scss">
.register-link {
  padding-top: 0px;
  @media (min-width: 768px) {
    padding-top: 24px;
  }
}
.languageToggle {
  input {
    border-style: none !important;
  }
}
</style>

<template>
    <div class="d-flex flex-column">
        <h1 class="text-center text-lg-left mb-16">{{ $t('pages.login.title') }}</h1>
        <p class="text-gold d-none d-lg-block">{{ $t('pages.login.sub_title') }}</p>

        <el-form @submit="submit" class="my-16 my-lg-auto">

            <template slot="default">

                <el-error class="mb-16" :error="server_error"></el-error>

                <div class="form-row my-auto">
                    <div class="col-12 col-xl-10">
                        <el-input v-model="data.email" type="email" rule="required" :name="$t('form-elements.email')" :label="$t('form-elements.email')" :placeholder="$t('form-elements.email_placeholder')" data-tc-email></el-input>
                    </div>
                    <div class="col-12 col-xl-10 mb-32">
                        <el-input v-model="data.password" type="password" rule="required" :name="$t('form-elements.password')" :label="$t('form-elements.password')" :placeholder="$t('form-elements.password_placeholder')" data-tc-password>
                            <template slot="label-cta">
                                <router-link :to="{ name: 'password-forgot' }" class="ml-auto text-primary-dark" data-tc-link-password-forgot>
                                    {{ $t('pages.login.cta_forgot_password') }}
                                </router-link>
                            </template>
                        </el-input>
                    </div>
                </div>
            </template>

            <template slot="footer">
                <button id="login_submit" class="btn btn-primary btn-block btn-lg-inline d-block d-lg-flex" v-bind:class="{ disabled : loading }" data-tc-submit>
                    {{ $t('pages.login.cta_submit') }}
                    <template v-if="loading">
                        <i-loader class="ml-2 i-20 my-auto"></i-loader>
                    </template>
                    <template v-if="success">
                        <i-check class="ml-2 i-20 my-auto"></i-check>
                    </template>
                </button>
            </template>

        </el-form>

        <div class="d-flex flex-row">
            <el-select class="col-5 col-lg-2 pl-0 languageToggle" @input="setLang" :options="languageArray" name='lang' :placeholder="currentLang"></el-select>

            <i18n path="pages.login.no_account_yet" tag="div" class="text-center text-lg-left register-link">
                <router-link :to="{ name: 'register' }" class="text-gold" data-tc-link-register>
                    {{ $t('pages.login.register') }}
                </router-link>
            </i18n>
        </div>

    </div>
</template>

<script>
import { ElInput, ElForm, ElError, ElSelect } from '@/components/forms'
// Extends
import { loadLanguageAsync } from '@/i18n'
import hasLanguages from '@/components/forms/has-languages';
import VueCookies from 'vue-cookies';

export default {
    name: 'page-login',
    mixins: [hasLanguages],
    components: { ElInput, ElForm, ElError, ElSelect },

    data: () => ({
        loading: false,
        success: false,
        server_error: null,
        data: {
            email: '',
            password: '',
            stay_signed_in: false
        },
        languageArray: ['NL', 'FR', 'EN'],
        currentLang: null,
        langSet: null,
    }),

    mounted() {

        if(this.$route.query.plan && ['basic', 'allin', 'all-in-one', 'diy'].includes(this.$route.query.plan)){
            let plan = this.$route.query.plan;
            // alias
            if(plan === 'all-in-one'){
               plan = 'allin'
            }
             VueCookies.set('set_plan', plan, 99999999);
        }
        if(this.$route.query.locked && ['true', 'false'].includes(this.$route.query.locked)){
             VueCookies.set('set_plan_locked', this.$route.query.locked, 99999999);
        }
        if (this.$route.query.referral) {
          VueCookies.set('referral_code', this.$route.query.referral, 99999999);
        }
        this.cleanLang(this.$i18n.locale)
    },

    methods: {
        submit() {
            this.$validator.validateAll().then(res => {
                if (res) {
                    this.loading = true
                    this.$store.dispatch('user/login', this.data).then(
                        () => {
                            this.loading = false
                            this.success = true
                            if (this.$route.query.redirect) {
                                this.$router.push(this.$route.query.redirect);
                            } else {
                                this.$router.push({ name: 'sleep-schedule' })
                            }
                        },
                        error => {
                            this.loading = false
                            this.success = false
                            this.server_error = error
                        }
                    )
                }
            })
        },
        cleanLang($lang) {
            if ($lang == 'fr-BE') {
                return this.currentLang = 'FR';
            }
            if ($lang == 'nl-BE') {
                return this.currentLang = 'NL';
            }
            if ($lang == 'en-GB') {
              return this.currentLang = 'EN';
            }
            else {
                return this.currentLang = 'NL';
            }
        },
        setLang(input) {
            if (input === 'NL') {
                this.langSet = 'nl-BE'
            }
            if (input === 'FR') {
                this.langSet = 'fr-BE'
            }
            if (input === 'EN') {
              this.langSet = 'en-GB'
            }
            loadLanguageAsync(this.langSet).then(() => {
                this.setLanguage(this.langSet)
            })
        },
    }
}
</script>
